import FileStrategy from './strategies/file';

const _strategies = {};
_strategies.file = FileStrategy;

const Factory = Object.freeze({
  create(type, config) {
    if (!_strategies.hasOwnProperty(type)) {throw Error('[AdBlockDetector] detector type not found');}
    return new _strategies[type](config);
  }
});

export default Factory;



// WEBPACK FOOTER //
// ./src/factory.js